// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"35316d3c","221":"cfb06a4a","568":"733391ea"}[chunkId] + ".chunk.js";
};